<template>
  <div
    class="asc-power-bi-my-airline-workspace-wrapper"
    data-automation-id="wrapper_power_bi_my_airline_workspace"
  >
    <template v-if="loading">
      <asc-spinner-wrapper loading></asc-spinner-wrapper>
    </template>
    <template v-if="airlineWorkspaces.length > 1 && !selectedWorkspace">
      <div>
        <asc-power-bi-workspace-grid
          :values="airlineWorkspaces"
          :update-selected-workspace="updateSelectedWorkspace"
          @updatePermissions="updatePermissions"
        ></asc-power-bi-workspace-grid>
      </div>
    </template>
    <template v-if="selectedWorkspace || airlineWorkspaces.length === 1">
      <div class="asc-power-bi-airline-workspace--content">
        <asc-power-bi-airline-workspace-grid
          :is-collins-workspace-tab="isCollinsWorkspaceTab"
          :values="airlineReports"
          :selected-workspace="
            selectedWorkspace ? selectedWorkspace : airlineWorkspaces[0]
          "
          :update-selected-dashboard="updateSelectedDashboard"
          @updatePermissions="updatePermissions"
          @handleDuplicateReport="handleDuplicateReport"
          @deleteReport="deleteReport"
          @handleSetReadonlyMode="handleSetReadonlyMode"
        >
        </asc-power-bi-airline-workspace-grid>
      </div>
    </template>
  </div>
</template>

<script>
import AscSpinnerWrapper from '../atoms/AscSpinnerWrapper.vue'
import AscPowerBiWorkspaceGrid from '../molecules/AscPowerBiWorkspaceGrid.vue'
import AscPowerBiAirlineWorkspaceGrid from '../molecules/AscPowerBiAirlineWorkspaceGrid.vue'
import { POWER_BI_CONSTS as PBI } from '@/stores/consts'
import { mapActions } from 'vuex'
import AscConfirmation from '@/components/molecules/AscConfirmation'

export default {
  name: 'AscPowerBiMyAirlineWorkspaceWrapper',

  components: {
    AscSpinnerWrapper,
    AscPowerBiWorkspaceGrid,
    AscPowerBiAirlineWorkspaceGrid,
    AscConfirmation,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    airlineWorkspaces: {
      type: Array,
      default: () => [],
    },
    airlineReports: {
      type: Array,
      default: () => [],
    },
    updateSelectedWorkspace: {
      type: Function,
      default: () => {},
    },
    selectedWorkspace: {
      type: Object,
      default: null,
    },
    isReportDuplicated: {
      type: Boolean,
      default: false,
    },
    updateSelectedDashboard: {
      type: Function,
      default: () => {},
    },
    isCollinsWorkspaceTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSharedPermission: '1',
      selectedObject: {},
    }
  },
  computed: {},
  methods: {
    ...mapActions(PBI.NAMESPACE, [
      PBI.CREATE_CLONE_POWERBI_DASHBOARD,
      PBI.GET_AIRLINE_REPORTS,
    ]),

    async handleDuplicateReport(selectedItem) {
      this.$emit('handleDuplicateReport', selectedItem)
    },
    updatePermissions(selectedItem) {
      this.$emit('updatePermissions', selectedItem)
    },
    deleteReport(selectedItem) {
      this.$emit('handleDeleteReport', selectedItem)
    },
    setPermissionsBody() {
      if (this.isSharedPermission === '1') {
        this.permissionsBody =
          'By selecting this option, all ' +
          this.permissionsAirline +
          ' users will be able to see and duplicate this dashboard.'
      } else if (this.isSharedPermission === '0') {
        this.permissionsBody =
          'By selecting this option, only I will be able to see this dashboard.'
      } else {
        this.permissionsBody = 'No Object Selected.'
      }
    },
    handleSharedPermissionChange() {
      this.setPermissionsBody()
    },
    handleSetReadonlyMode(value) {
      this.$emit('handleSetReadonlyMode', value)
    },
  },
}
</script>

<style lang="scss">
.power-bi-permission-dialog {
  & .asc-dialog-subtitle {
    width: 30px;
  }
  .permissions-radio-group {
    margin-top: 4px;
    .v-icon {
      font-size: 20px;
    }
    .v-input--selection-controls__ripple {
      height: 30px;
      width: 30px;
      left: -10px;
    }
    label {
      font-size: 14px;
      text-transform: capitalize;
      color: $gray-1000;
    }
  }
  .permissions-description {
    font-size: 12px;
    margin-top: 16px;
  }
}
</style>
